// The base path under which each week's deliverable mounts the product
export const W4Base = "/w4";
export const W5Base = "/w5";
